import React from "react";

export default function SocialProof() {
  const INTEREST_COUNT = 1200; // update manually or via backend later

  return (
    <section className="py-16 bg-white text-center px-4">
      <h3 className="text-3xl font-bold mb-4">
        Trusted by Health-Conscious Families & Institutions
      </h3>

      <p className="text-gray-600 mb-6">
        Over <strong>{INTEREST_COUNT}+ households & Institutions </strong> have already
        shown interest in AERZEN AIR™ Early Access.
      </p>

      <div className="inline-block bg-[var(--aerzen-blue)]/10 text-[var(--aerzen-blue)] px-6 py-3 rounded-full text-sm font-medium">
        Early Access slots are limited · Allocation based on order sequence
      </div>
    </section>
  );
}
